import { createSelector } from 'reselect';
import { ApplicationRootState } from 'types';
import { initialState } from './reducer';

/**
 * Direct selector to the checkoutPage state domain
 */

const selectCheckoutPageDomain = (state: ApplicationRootState) => {
  return state ? state.checkoutPage : initialState;
};

/**
 * Other specific selectors
 */

/**
 * Default selector used by CheckoutPage
 */

const selectCheckoutPage = () =>
  createSelector(selectCheckoutPageDomain, (substate) => {
    return substate;
  });

const selectOrderDraftToken = () =>
  createSelector(selectCheckoutPageDomain, (substate) => {
    return substate.orderDraftToken;
  });

const selectCheckout = () =>
  createSelector(selectCheckoutPageDomain, (substate) => {
    return substate.checkout;
  });

const selectLoadingCheckout = () =>
  createSelector(selectCheckoutPageDomain, (substate) => {
    return substate.loading;
  });

const selectCheckoutStatus = () =>
  createSelector(selectCheckoutPageDomain, (substate) => {
    return substate.checkoutStatus;
  });

const selectOpenConfirmSameDayDeliveryModal = () =>
  createSelector(selectCheckoutPageDomain, (substate) => {
    return substate.openConfirmSameDayDeliveryModal;
  });

const selectOpenModalSomthingChanged = () =>
  createSelector(selectCheckoutPageDomain, (substate) => {
    return substate.somethingChanged;
  });

const selectVoucherPopup = () =>
  createSelector(selectCheckoutPageDomain, (substate) => substate.vouchers);

const selectVouchers = () => createSelector(selectCheckoutPageDomain, (substate) => substate.vouchers.data);

const selectCurrentAppliedVoucher = () => createSelector(selectCheckoutPageDomain, (substate) => substate.vouchers.currentAppliedVoucher);

const selectVoucherStatus = () => createSelector(selectCheckoutPageDomain, (substate) => substate.vouchers.status);

const selectDiscountedValue = () => createSelector(selectCheckoutPageDomain, (substate) => substate.vouchers.discountedValue);

const selectVoucherLoading = () => createSelector(selectCheckoutPageDomain, (substate) => substate.vouchers.loading);

export default selectCheckoutPage;
export {
  selectCheckoutPageDomain,
  selectOrderDraftToken,
  selectCheckout,
  selectCheckoutStatus,
  selectLoadingCheckout,
  selectOpenConfirmSameDayDeliveryModal,
  selectOpenModalSomthingChanged,
  selectVoucherPopup,
  selectVouchers,
  selectCurrentAppliedVoucher,
  selectVoucherStatus,
  selectDiscountedValue,
  selectVoucherLoading,
};
